import { render } from "./horizondalgroupbarchart.vue?vue&type=template&id=83faf650&scoped=true"
import script from "./horizondalgroupbarchart.vue?vue&type=script&lang=js"
export * from "./horizondalgroupbarchart.vue?vue&type=script&lang=js"

import "./horizondalgroupbarchart.vue?vue&type=style&index=0&id=83faf650&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83faf650"]])

export default __exports__